import { render, staticRenderFns } from "./FindLicensingCommunity.vue?vue&type=template&id=714854a0&scoped=true&"
import script from "./FindLicensingCommunity.vue?vue&type=script&lang=js&"
export * from "./FindLicensingCommunity.vue?vue&type=script&lang=js&"
import style0 from "./FindLicensingCommunity.vue?vue&type=style&index=0&id=714854a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714854a0",
  null
  
)

export default component.exports